export const IdentidadCulturalOptions = [
    {text: 'Garifuna', value: 'GA'},
    {text: 'Ladino/Mestizo', value: 'LA'},
    {text: 'Maya', value: 'MA'},
    {text: 'Xinca', value: 'XI'},
    {text: 'Otros', value: 'OT'},
]